import { type ReactNode, useEffect } from 'react';
import { applyPrimaryTheme, getStoredCustomPrimaryColor, getStoredPrimaryThemeId } from '@/lib/theme/primary-theme';
import { applyFontTheme, getStoredFontThemeId } from '@/lib/theme/font-theme';

export function PrimaryThemeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    applyPrimaryTheme(getStoredPrimaryThemeId(), getStoredCustomPrimaryColor());
    applyFontTheme(getStoredFontThemeId());
  }, []);

  return <>{children}</>;
}
